/* tslint:disable */
/* eslint-disable */
export enum AssignmentState {
  Active = 'active',
  Deleted = 'deleted',
  Expired = 'expired'
}
